export default "__VITE_ASSET__06f45db3__"